import { QUICK_ITEMS, QUICKLIST_BY_STEP } from "../constants/quickItems"
import { STEP_BY_PATH } from "../constants/stepByPath"

export function getQuickList(pathname) {
  const stepId = STEP_BY_PATH[pathname]
  if (!stepId) return []
  const keys = QUICKLIST_BY_STEP[stepId] ?? []
  return keys.map((k) => QUICK_ITEMS[k])
}
